"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhatWeUse = void 0;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
var WhatWeUse = function WhatWeUse(_ref) { var children = _ref.children, title = _ref.title; return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", { className: "what-we-use" }, /*#__PURE__*/ React.createElement(Container, { className: "container-fluid" }, /*#__PURE__*/ React.createElement(Title, null, title), children))); };
exports.WhatWeUse = WhatWeUse;
var Container = styled_components_1.default.div.withConfig({ displayName: "WhatWeUse__Container", componentId: "sc-1qm2ahl-0" })(["padding:60px 0;background-color:#fff;text-align:center;"]);
var Title = styled_components_1.default.h2.withConfig({ displayName: "WhatWeUse__Title", componentId: "sc-1qm2ahl-1" })(["color:#4b7892;margin-bottom:20px;"]);
exports.default = exports.WhatWeUse;
